import { render } from "./collectSingle.vue?vue&type=template&id=4226fbd8&scoped=true"
import script from "./collectSingle.vue?vue&type=script&lang=js"
export * from "./collectSingle.vue?vue&type=script&lang=js"

import "./collectSingle.vue?vue&type=style&index=0&id=4226fbd8&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4226fbd8"]])

export default __exports__